import {
  SwipeableProgressRatio,
  SwipeableSlider,
  useGoToSwipeableSlide,
  useSwipeable,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import { Fragment } from 'react';

import { type GalleryImageData } from '../types';
import GallerySlide from './GallerySlide';
import SliderButton from './SliderButton';

export interface GalleryProps {
  readonly images: GalleryImageData[];
}

const Gallery = ({ images }: GalleryProps): JSX.Element => {
  const t = useTranslations();
  const { canScrollNext, canScrollPrev } = useSwipeable();
  const { activeSlide, goToSlide } = useGoToSwipeableSlide();

  return (
    <div className="relative inset-0 z-10 size-full">
      <div className="absolute bottom-36 z-10 hidden w-full md:block lg:bottom-48">
        <SliderButton
          disabled={!canScrollPrev}
          className="left-48"
          onClick={() => goToSlide(activeSlide - 1)}
        >
          <span aria-hidden="true">&larr;</span>
          <span className="sr-only">{t('previous_slide_aria_label')}</span>
        </SliderButton>
        <SliderButton
          disabled={!canScrollNext}
          className="right-48"
          onClick={() => goToSlide(activeSlide + 1)}
        >
          <span aria-hidden="true">&rarr;</span>
          <span className="sr-only">{t('next_slide_aria_label')}</span>
        </SliderButton>
      </div>
      <div className="flex flex-col-reverse">
        <SwipeableProgressRatio className="mt-3 text-blue-200" />
        <SwipeableSlider slideClassName="snap-center">
          {images.map((image, idx) => (
            <Fragment key={image.src}>
              <GallerySlide image={image} isActive={activeSlide === idx} />
            </Fragment>
          ))}
        </SwipeableSlider>
      </div>
    </div>
  );
};

export default Gallery;
